import { render, staticRenderFns } from "./R02.vue?vue&type=template&id=164ef8f2&scoped=true"
import script from "./R02.vue?vue&type=script&lang=js"
export * from "./R02.vue?vue&type=script&lang=js"
import style0 from "./R02.vue?vue&type=style&index=0&id=164ef8f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164ef8f2",
  null
  
)

export default component.exports